import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LeftArrowIcon, TipsIcon } from '@/components/common/icon';
import { Drawer, Tooltip } from 'aha-components';
import { isMobile } from '@/biz/tool';

export default function FairRangeEstimateHint() {
  const { t } = useTranslation();
  const [showFairRangeDrawer, setShowFairRangeDrawer] = useState(false);
  const mobile = isMobile();
  const fairRangeTitle = t(
    'price.fields.set_your_rate.fair_range_estimate_link',
    {
      defaultValue: 'How we estimate fair price range'
    }
  );
  const fairRangeContent = t('price.fields.set_your_rate.fair_range_tooltip', {
    defaultValue:
      "The fair price range is the market rate for this deal. It's estimated from recent deals by similar creators, factoring in your audience, niche, channel performance (e.g.average views, follower counts), and how well you fit this brand. Pricing within this range makes sure you're paid what your work is worth while keeping your chance of landing the collaboration as high as possible."
  });
  const fairRangeLink = (
    <div className="flex items-center gap-1">
      <TipsIcon />
      <div className="justify-start text-text-primary text-sm font-normal font-['DM_Sans'] leading-5">
        {fairRangeTitle}
      </div>
    </div>
  );

  if (mobile) {
    return (
      <>
        <div
          className="cursor-pointer"
          onClick={() => setShowFairRangeDrawer(true)}
        >
          {fairRangeLink}
        </div>
        <Drawer
          open={showFairRangeDrawer}
          onClose={() => setShowFairRangeDrawer(false)}
          placement="bottom"
          height="auto"
          closable={false}
          drawerStyle={{
            borderRadius: '16px 16px 0 0'
          }}
          bodyStyle={{ padding: 0 }}
        >
          <div className="flex flex-col gap-4 px-4 pt-4 pb-[calc(16px+env(safe-area-inset-bottom,0px))]">
            <div className="flex items-center gap-2">
              <button
                type="button"
                className="flex-shrink-0"
                onClick={() => setShowFairRangeDrawer(false)}
              >
                <LeftArrowIcon className="w-6 h-6" />
              </button>
              <div className="justify-start text-Colors-Text-text-primary-(900) text-lg font-semibold font-['Inter'] leading-7">
                {fairRangeTitle}
              </div>
            </div>
            <div className="self-stretch justify-start text-Colors-Text-text-primary-(900) text-lg font-normal font-['Inter'] leading-7">
              {fairRangeContent}
            </div>
          </div>
        </Drawer>
      </>
    );
  }

  return <Tooltip content={fairRangeContent}>{fairRangeLink}</Tooltip>;
}
